import * as tslib_1 from "tslib";
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
var CredentialStoreDeleteModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CredentialStoreDeleteModalComponent, _super);
    function CredentialStoreDeleteModalComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CredentialStoreDeleteModalComponent.prototype.onConfirm = function () {
        this._dialogRef.close({
            type: 4 /* Succeeded */,
        });
    };
    return CredentialStoreDeleteModalComponent;
}(UiModalComponent));
export { CredentialStoreDeleteModalComponent };
